import React, { useContext } from 'react';

// React router dom
import { BrowserRouter, Redirect, Route, Switch, useHistory } from 'react-router-dom';

// Context
import AuthContext from './Context/context';

// Pages
import Login from './pages/Login/index';
import Cadastro from './pages/Cadastro/index';
import Home from './pages/Home/index';
import UsuariosAdmin from './pages/UsuariosAdmin/index';
import Mods from './pages/ModsLinks/index';
import Categorias from './pages/Categorias/index';
import EmailVerification from './pages/EmailVerification/index';
import ConfigModsAtivosAdmin from './pages/ConfigModsAtivosAdmin/index';
import ModsAtivos from './pages/ModsAtivos/index';
import NotAuthenticatedPage from './pages/NotAuthenticated/index';
import Tutoriais from './pages/Tutoriais/index';

function Routes() {
  const { isAdmin, isLogged, emailVerified } = useContext(AuthContext)

  const getToken = () => {
    return localStorage.getItem('_tok_user');
  }

  // Rota privada para impedir usuários de entrarem em páginas quando não logados
  const PrivateRouteCommon = ({ Component, ...rest }: any) => {
    let history = useHistory();
    return (
      <Route
        {...rest}
        render={props =>
          // Se sim, renderiza de acordo com a rota solicitada e permitida
          // Se não, redireciona para a página de login
          isLogged ? (<Component {...props} />) : (<Redirect to={{ pathname: "/permission-denied" }} />)
        }
      />
    )
  };

  // Rota privada para impedir usuários de entrarem em páginas de administrador
  const PrivateRouteAdmin = ({ Component, ...rest }: any) => {
    let history = useHistory();
    return (
      <Route
        {...rest}
        render={props =>
          // Se sim, renderiza de acordo com a rota solicitada e permitida
          // Se não, redireciona para a página de login
          getToken() !== null && isAdmin ? (<Component {...props} />) : history.goBack()
        }
      />
    )
  };

  // Para usuários não terem permissão de entrar em páginas próprias de usuários não autenticados
  const NotAuthenticated = ({ Component, ...rest }: any) => {
    return (
      <Route
        {...rest}
        render={props =>
          // Se sim, renderiza de acordo com a rota solicitada e permitida
          // Se não, redireciona para a página de login
          getToken() == null ? (<Component {...props} />) : (<Redirect to={{ pathname: "/" }} />)
        }
      />
    )
  };

  // Para usuarios que não estejam com email verificado não terem permissão de entrar na página
  const EmailNotVerified = ({ Component, ...rest }: any) => {
    return (
      <Route
        {...rest}
        render={props =>
          // Se sim, renderiza de acordo com a rota solicitada e permitida
          // Se não, redireciona para a página de login
          !emailVerified ? (<Component {...props} />) : (<Redirect to={{ pathname: "/" }} />)
        }
      />
    )
  };

  return (
    <BrowserRouter>
      <Switch>
        {/* o 'C' de Component deve estar maiúsculo para funcionar rotas privadas */}
        <Route path="/" exact component={Home} />
        <Route path="/email-verification" component={EmailVerification} />
        <Route path="/tutoriais" component={Tutoriais} />
        <NotAuthenticated path="/login" Component={Login} />
        <NotAuthenticated path="/cadastro" Component={Cadastro} />
        <EmailNotVerified path="/permission-denied" Component={NotAuthenticatedPage} />
        <PrivateRouteAdmin path="/usuarios" Component={UsuariosAdmin} />
        <PrivateRouteAdmin path="/config/mods-ativos/:jogo" Component={ConfigModsAtivosAdmin} />
        <Route path="/mods-ativos/:jogo" component={ModsAtivos} />
        <Route path="/mods/:jogo/:categoria" component={Mods} />
        <Route path="/categorias/:jogo" component={Categorias} />
      </Switch>
    </BrowserRouter>
  );
}

export default Routes;